import * as React from "react";

function CheckCircleOutline(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props, {
    style: Object.assign({
      verticalAlign: '-0.125em'
    }, props.style),
    className: ['antd-mobile-icon', props.className].filter(Boolean).join(' ')
  }), /*#__PURE__*/React.createElement("title", null, "F221CA15-2243-465A-A545-388197237FCB@2x"), /*#__PURE__*/React.createElement("g", {
    id: "CheckCircleOutline-CheckCircleOutline",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "CheckCircleOutline-\u7F16\u7EC4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "CheckCircleOutline-\u77E9\u5F62",
    fill: "#FFFFFF",
    opacity: 0,
    x: 0,
    y: 0,
    width: 48,
    height: 48
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24,2 C36.1502645,2 46,11.8497355 46,24 C46,36.1502645 36.1502645,46 24,46 C11.8497355,46 2,36.1502645 2,24 C2,11.8497355 11.8497355,2 24,2 Z M24,5 C13.5065898,5 5,13.5065898 5,24 C5,34.4934102 13.5065898,43 24,43 C34.4934102,43 43,34.4934102 43,24 C43,13.5065898 34.4934102,5 24,5 Z M35.9397591,17.682013 L23.3431458,30.2781746 L23.3431458,30.2781746 C22.7573593,30.863961 21.8076118,30.863961 21.2218254,30.2781746 L21.1448618,30.1962736 C21.0355278,30.1325525 20.932526,30.0538463 20.8388348,29.9601551 L13.5613926,22.681994 C13.4051906,22.5257765 13.4052031,22.2725106 13.5614206,22.1163086 C13.636434,22.0413025 13.7381696,21.9991652 13.8442493,21.9991652 L16.9549543,21.9991652 C17.0610359,21.9991652 17.1627731,22.041304 17.2377869,22.1163124 L22.25,27.1281652 L22.25,27.1281652 L32.2624756,17.1163137 C32.3374894,17.0413045 32.4392272,16.9991652 32.5453095,16.9991652 L35.6569214,16.9991652 C35.8778353,16.9991652 36.0569214,17.1782513 36.0569214,17.3991652 C36.0569214,17.5052543 36.0147767,17.6069981 35.9397591,17.682013 Z",
    id: "CheckCircleOutline-\u5F62\u72B6",
    fill: "currentColor"
  }))));
}

export default CheckCircleOutline;